// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__eO1m-","image":"not-found_image__GvOWT"};